import React, { useState } from "react";
import { Field, Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { SmallLoader } from "../../Common/Loader";
import { updataClientApi } from "../../../services/client/addclientApi";
import { fetchCustomerData } from "../../../Redux/clientsSlice";
import CustomerActivationModale from "../../Common/CustomertActivationModale";
import pencilIcon from "../../../assets/icons/pencil.png";
import { useParams } from "react-router-dom";
import { roleClasses, subscriptionStatusClass } from "../../Common/roles";
import PhoneInput from "react-phone-input-2";
import moment from "moment";
import { BsPencil } from "react-icons/bs";
import { PiCircleThin } from "react-icons/pi";

export function isUnder23(dob) {
  if (!dob) return false;

  const birthDate = new Date(dob);
  const today = new Date();

  // Calculate age
  const age = today.getFullYear() - birthDate.getFullYear();

  // Adjust for cases where the birthday hasn't occurred yet this year
  const isBirthdayPassed =
    today.getMonth() > birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() &&
      today.getDate() >= birthDate.getDate());

  const actualAge = isBirthdayPassed ? age : age - 1;

  return actualAge < 23;
}

const ProspectDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [isEdit, setEdit] = useState(true);
  const [isLoding, setLoding] = useState(false);
  const [isModelShow, setModelShow] = useState(false);
  const { customerData } = useSelector((state) => state?.clientsSlice);

  const initialValues = {
    firstname: customerData?.customer?.firstname || "",
    lastname: customerData?.customer?.lastname || "",
    email: customerData?.customer?.email || "",
    contact: `${customerData?.customer?.phonenumber}` || "",
    DOB: `${customerData?.customer?.DOB}` || "",
    address: `${customerData?.customer?.address}`,
    createdAt: `${customerData?.customer?.createdAt}`,
    language: customerData?.customer?.language || "",
  };
  const prospectUnder23 = customerData?.customer?.DOB
    ? isUnder23(customerData?.customer?.DOB)
    : false;
  const hasLicenseMoreThan5Years =
    customerData?.customer?.license_more_than_5years || false;

  return (
    <div>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={async (values) => {
          setLoding(true);
          const formData = new FormData();
          formData.append("firstname", values.firstname);
          formData.append("lastname", values.lastname);
          if (values.email !== customerData?.customer?.email) {
            formData.append("email", values.email);
            formData.append("active", false);
          }
          formData.append("contact", values.contact);
          formData.append("DOB", values.DOB);

          const data = await updataClientApi(id, formData);

          if (data) {
            dispatch(fetchCustomerData(id));
            setEdit(true);
            setLoding(false);
          }
        }}
      >
        {({ values, setFieldValue }) => (
          <Form className="card mb-4">
            <div className="card-body">
              <div className="d-flex justify-content-between position-relative">
                <div className="position-absolute left-0 top-0">
                  {isEdit && (
                    <button
                      className="btn waves-effect waves-light p-0 align-items-start"
                      onClick={() => {
                        setEdit(false);
                      }}
                    >
                      <BsPencil className="dark-body-text" />
                      {/* <img src={pencilIcon} alt="pencil-icon" /> */}
                    </button>
                  )}
                </div>
                <div>
                  {!isEdit && (
                    <button
                      type="submit"
                      className="btn btn-primary waves-effect waves-light"
                    >
                      Save
                      {isLoding && <SmallLoader />}
                    </button>
                  )}
                </div>
                <div className="mx-auto">
                  <div className="text-center d-flex justify-content-center gap-2">
                    <h4 className="dark-heading">
                      {customerData?.customer?.firstname}{" "}
                      {customerData?.customer?.lastname}
                    </h4>
                  </div>

                  <div className="d-flex justify-content-center gap-2 ">
                    <span className={roleClasses[customerData?.customer?.role]}>
                      {customerData?.customer?.role}
                    </span>
                    {customerData?.customer?.beclient === "true" &&
                      !prospectUnder23 && (
                        <span className="bg-success rounded px-2 c-badge">
                          <i
                            className="menu-icon text-white tf-icons ti ti-checkup-list m-0 fs-5"
                            type="button"
                          />
                        </span>
                      )}
                    {customerData?.customer?.beclient === "false" &&
                      customerData?.customer?.phonenumber_verified &&
                      !prospectUnder23 && (
                        <span className="bg-warning rounded px-2 c-badge">
                          <i
                            className="menu-icon text-white tf-icons ti ti-file m-0 fs-5"
                            type="button"
                          />
                        </span>
                      )}
                    {(prospectUnder23 || !hasLicenseMoreThan5Years) && (
                      <span className="bg-warning rounded px-2 c-badge">
                        <i
                          className="menu-icon text-white tf-icons ti ti-id-badge m-0 fs-5"
                          type="button"
                        />
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <hr />
              <small className="card-text text-uppercase dark-heading">
                Prospect Detail
              </small>

              <ul className="list-unstyled mb-4 mt-3">
                <li className="d-flex align-items-center justify-content-between mb-3">
                  <i className="ti ti-mail dark-body-text" />
                  <span className="fw-medium mx-2 text-heading dark-heading">
                    Email:
                  </span>
                  <Field
                    readOnly={isEdit}
                    name="email"
                    value={values?.email}
                    placeholder="email"
                    className={`dark-body-text dark-input ${
                      isEdit ? "hide-input" : "form-control"
                    }`}
                  />
                  {isEdit === true &&
                    customerData?.customer?.active === false && (
                      <div
                        className="text-primary text-decoration-underline cursor-pointer"
                        onClick={(e) => {
                          setModelShow(true);
                        }}
                      >
                        Activate
                      </div>
                    )}
                </li>

                <li className="d-flex align-items-center mb-3">
                  <i className="ti ti-phone-call dark-heading" />
                  <span className="fw-medium mx-2 text-heading dark-heading">
                    Contact:
                  </span>
                  <PhoneInput
                    disabled={isEdit}
                    country={"Luxembourg"}
                    enableSearch={true}
                    className={`dark-body-text dark-input ${
                      isEdit ? "hide-input" : "form-control"
                    } `}
                    placeholder="+352 369 852 472"
                    value={values?.contact}
                    onChange={(value) => setFieldValue("contact", value)}
                  />
                </li>

                <li className="d-flex align-items-center mb-3 position-relative">
                  <span className="fw-medium mx-2 text-heading dark-heading">
                    DOB:
                  </span>
                  <Field
                    readOnly={isEdit}
                    name="DOB"
                    value={
                      values?.DOB
                        ? moment(values?.DOB).format("YYYY-MM-DD")
                        : ""
                    }
                    placeholder="DOB"
                    type="date"
                    className={`dark-body-text dark-input ${
                      isEdit ? "hide-input" : "form-control"
                    }`}
                  />

                  {(prospectUnder23 || !hasLicenseMoreThan5Years) && (
                    <div>
                      <PiCircleThin
                        className={`circle-chk`}
                        style={{
                          backgroundColor: "rgba( 255, 159, 67, 1 )",
                        }}
                        fontSize={20}
                      />
                    </div>
                  )}
                </li>

                <li className="d-flex align-items-start mb-3">
                  <span className="fw-medium mx-2 text-heading dark-heading">
                    Address:
                  </span>
                  <div className={`dark-body-text`}>{values?.address}</div>
                </li>

                <li className="d-flex align-items-center mb-3">
                  <span className="fw-medium mx-2 text-heading dark-heading flex-1">
                    Date of creation:
                  </span>
                  <div className={`dark-body-text`}>
                    <Field
                      readOnly={isEdit}
                      name="createdAt"
                      value={
                        values?.createdAt
                          ? moment(values?.createdAt).format("YYYY-MM-DD")
                          : ""
                      }
                      placeholder="Date of creation"
                      type="date"
                      className={`dark-body-text dark-input hide-input`}
                    />
                  </div>
                </li>

                <li className="d-flex align-items-center mb-3">
                  <span className="fw-medium mx-2 text-heading dark-heading flex-1">
                    Language:
                  </span>
                  <div className={`dark-body-text dark-text`}>
                    <Field
                      readOnly={isEdit}
                      name="language"
                      value={values?.language}
                      placeholder="Language"
                      type="text"
                      className={`dark-body-text dark-input hide-input`}
                    />
                  </div>
                </li>
              </ul>
            </div>
          </Form>
        )}
      </Formik>

      {isModelShow && (
        <CustomerActivationModale
          show={isModelShow}
          onHide={() => setModelShow(false)}
          title={" are you sure you want ot send active link"}
          id={id}
        />
      )}
    </div>
  );
};

export default ProspectDetails;
